import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'
import { Status } from '../../models/User'
import { OverviewUser } from '../../models/User'
export const useGetFirstHeaders = () => {
  const { t } = useTranslation()

  return [
    {
      accessor: 'name',
      label: t('Users.name'),
      searchType: 'search',
    },
    {
      accessor: 'email',
      label: t('Users.email'),
      searchType: 'search',
    },
  ]
}
export const useGetLastHeaders = (statuses: Status[]) => {
  const { t } = useTranslation()

  return [
    {
      accessor: 'status',
      label: t('Users.status'),
      searchType: 'select',
      options: statuses,
    },
    {
      accessor: 'action',
      label: t('Users.actions'),
      searchType: '',
    },
  ]
}

export const getColorForStatus = (status: string) => {
  switch (status) {
    case 'Pending approval':
      return '#E2266A'
    case 'Invitation expired':
      return '#E2266A'
    case 'Invitation sent':
      return '#00A0A6'
    case 'Inactive':
      return '#26282F'
    default:
      return '#26282F'
  }
}

export const useGetMe = (users: OverviewUser[]) => {
  const { userId } = useAuth()
  if (!users || !users?.length) return null
  return users.find((user) => user.objectId === userId || user.id === userId)
}
